<template>
    <div class="mtr-container">
        <div class="_section">
            <MkTextarea v-model="comment">
                <template #label>{{ $t("details") }}</template>
                <template #caption
                    >{{ $t("fillAbuseReportDescription") }}
                </template>
            </MkTextarea>
        </div>
        <MagFormButtonRow @click="send" :disabled="!Boolean(comment)">
            <template #icon>
                <mg-icon icon="paper-plane-tilt" marginEnd="true" />
            </template>
            <template #label>
                {{ $t("send") }}
            </template>
        </MagFormButtonRow>
    </div>
</template>

<script setup lang="ts">
import { useFluent } from "fluent-vue";
import MkTextarea from "@/components/form/textarea.vue";
import { TileControls, TileReportProps } from "@/store/tile-store";
import { ref, watchEffect } from "vue";
import { legacyApi } from "@/api-client";
import { asyncDialog } from "@/dialog-legacy";
import { messageAlert } from "@/composables/message-box";
import MagFormButtonRow from "@/components/form/MagFormButtonRow.vue";

const { $t } = useFluent();

const props = defineProps<
    TileReportProps & {
        controls: TileControls;
    }
>();

const comment = ref(props.reportText || "");

function send() {
    asyncDialog(
        legacyApi("users/report-abuse", {
            userId: props.user.id,
            comment: comment.value,
        }),
    ).then((res) => {
        res.peek(() => {
            messageAlert({
                type: "success",
                text: $t("abuseReported"),
            });

            props.controls.setClosing();
        });
    });
}

watchEffect(() => {
    props.controls.setTitle(
        $t("reportAbuseOf", { name: props.user?.acct ?? $t("user") }),
    );
});
</script>

<style scoped lang="scss">
.mtr-container {
    min-height: 100%;
    background: var(--bg);
    padding: 20px;
}
</style>
